<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/processOutput/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button v-if="$checkBtnPermission('/processOutput/index', 'reset')" size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="出库单号：">
					<el-input clearable v-model="formInline.outputStoreNo" size="small" placeholder="请输入出库单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="加工单号：">
					<el-input clearable v-model="formInline.processOrderNo" size="small" placeholder="请输入加工单号" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="出库方式：">
					<el-select v-model.number="formInline.outputType" placeholder="请选择出库方式" size="small" @change="search">
						<el-option label="全部" :value="0"></el-option>
						<el-option v-for="item in outputTypeList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="出库状态：">
					<el-select v-model.number="formInline.state" placeholder="请选择出库状态" size="small" @change="search">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="正常" :value="1"></el-option>
						<el-option label="已作废" :value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="顾客姓名：">
					<el-input clearable v-model="formInline.customerName" size="small" placeholder="请输入顾客姓名" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="顾客电话：">
					<el-input clearable v-model="formInline.customerPhone" size="small" placeholder="请输入顾客电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="出库时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border height="480" @get-data="getListData">
				<template #outputStoreNo>
					<el-table-column align="center" label="出库单号" width="230">
						<template #default="scope">
							<el-link type="primary" size="small" @click="handleSeeDetail(scope.row)">{{ scope.row.outputStoreNo }}</el-link>
						</template>
					</el-table-column>
				</template>
				<template #stateStr>
					<el-table-column align="center" label="出库状态" width="100">
						<template #default="scope">
							<span v-if="scope.row.state === 2" class="text-danger">已作废</span>
							<span v-else>正常</span>
						</template>
					</el-table-column>
				</template>
				<template #operate>
					<el-table-column align="center" label="操作" width="90" fixed="right">
						<template #default="scope">
							<el-button type="text" size="small" @click="handleSeeDetail(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<processOutputDetail ref="processOutputDetail"></processOutputDetail>
	</div>
</template>

<script>
import { GetProcessOutputStorePageList } from "@/api/processApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import processOutputDetail from "./detail.vue";
export default {
	components: {
		processOutputDetail
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "出库单列表"
				}
			],
			pageShow: true,
			loading: false,
			listData: [],
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			dateValue: [],
			outputTypeList: [],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				outputStoreNo: "",
				processOrderNo: "",
				outputType: 0,
				state: 0,
				customerName: "",
				customerPhone: "",
				startTime: null,
				endTime: null
			},
			columnsData: [],
			listColumns: [
				{ prop: "rowNumber", label: "序号", align: "center", width: "70", isKeep: true },
				{ slot: "outputStoreNo", label: "出库单号", align: "center", isKeep: true, width: "230" },
				{ prop: "processOrderNo", label: "加工单号", align: "center", isKeep: true, width: "220" },
				{ prop: "outputTypeStr", label: "出库方式", align: "center", isKeep: true, width: "120" },
				{ slot: "stateStr", label: "出库状态", align: "center", isKeep: true, width: "100" },
				{ prop: "belongStoreName", label: "收货门店", align: "center", width: "140" },
				{ prop: "customerName", label: "顾客姓名", align: "center", width: "100" },
				{ prop: "outputUserName", label: "出库人", align: "center", width: "100" },
				{ prop: "outputDate", label: "出库时间", align: "center", width: "170" },
				{ prop: "cancelUser", label: "作废人", align: "center", width: "100" },
				{ prop: "cancelTime", label: "作废时间", align: "center", width: "170" },
				{ prop: "remark", label: "备注", align: "center", minWidth: "160" },
				{ prop: "creator", label: "创建人", align: "center", width: "100" },
				{ prop: "createTime", label: "创建时间", align: "center", width: "170" },
				{ slot: "operate", label: "操作", align: "center", isKeep: true, width: "90" }
			]
		};
	},
	created() {
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getEnumConfigListByCode();
		this.getListData();
	},
	methods: {
			changePages(tab) {
				this.activeTab = tab;
			},
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		getEnumConfigListByCode() {
			GetEnumConfigListByCode({ code: "ProcessOutputType" })
				.then((res) => {
					if (res.code == 1) {
						this.outputTypeList = res.data || [];
					}
				})
				.catch(() => {});
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		// 后端 int 型筛选字段不接受 null/空串（System.Text.Json 会直接返回 400），统一归一化为 0（0=不筛选）
		normalizeQuery() {
			["outputType", "state"].forEach((key) => {
				const val = this.formInline[key];
				if (val === null || val === undefined || val === "") this.formInline[key] = 0;
			});
		},
		getListData() {
			this.normalizeQuery();
			this.loading = true;
			GetProcessOutputStorePageList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data || [];
						this.pageparm.total = res.totalNumber;
					} else {
						this.listData = [];
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.dateValue = [];
			this.search();
		},
		inputChange() {
			this.search();
		},
		callFather(parm) {
			this.formInline.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleSeeDetail(row) {
			this.$refs.processOutputDetail.showSeeDetailDialog(row);
		}
	}
};
</script>

<style scoped>
.text-danger {
	color: var(--app-danger);
}
</style>
